import { html } from "htm/preact";
import { hydrate } from "preact";
import PageSections from "../components/PageSections.js";
const el = document.getElementById("page-sections-island");
if (el) {
  const title = el.dataset.title;
  const sections = JSON.parse(document.getElementById("sections").innerHTML);
  
  hydrate(html`<${PageSections} title=${title} sections=${sections} />`, el);
}